var map = {
	"./2048.jpg": 593,
	"./2048.webp": 5963,
	"./3D-Air-Hockey.jpg": 923,
	"./3D-Air-Hockey.webp": 6731,
	"./3D-Bowling.jpg": 5209,
	"./3D-Bowling.webp": 2179,
	"./8-Ball-Billiards-Classic.jpg": 955,
	"./8-Ball-Billiards-Classic.webp": 8713,
	"./Air-Battle-Royale-Sky-Blitz.jpg": 7047,
	"./Air-Battle-Royale-Sky-Blitz.webp": 9547,
	"./AitBattle.webp": 3275,
	"./AngryHeroes.webp": 4746,
	"./BFFs-K-Pop-Fangirls.jpg": 6975,
	"./BFFs-K-Pop-Fangirls.webp": 9811,
	"./Basket-Monsterz.jpg": 5236,
	"./Basket-Monsterz.webp": 2886,
	"./BasketBros.jpg": 1627,
	"./BasketBros.webp": 9185,
	"./Battle-Arena.jpg": 9283,
	"./Battle-Arena.webp": 3613,
	"./Bloxd.webp": 7584,
	"./Bolts-and-Nuts.jpg": 6542,
	"./Bolts-and-Nuts.webp": 2130,
	"./Bubble Blast.jpg": 2803,
	"./Bubble Blast.webp": 8965,
	"./Capybara-Clicker.jpg": 3148,
	"./Capybara-Clicker.webp": 5724,
	"./Car-Clash-2.jpg": 4556,
	"./Car-Clash-2.webp": 1821,
	"./Chess-Nations.jpg": 8572,
	"./Chess-Nations.webp": 246,
	"./ChessOnlineMultiplayer.webp": 4288,
	"./Crazy-Drift.jpg": 9374,
	"./Crazy-Drift.webp": 1392,
	"./Crazy-Roll-3D.jpg": 3176,
	"./Crazy-Roll-3D.webp": 4510,
	"./Cricket-World-Cup.jpg": 5338,
	"./Cricket-World-Cup.webp": 3892,
	"./Crocword.jpg": 7426,
	"./Crocword.webp": 3330,
	"./Cubes 2048.webp": 6033,
	"./Cut-the-Rope.jpg": 1480,
	"./Cut-the-Rope.webp": 9392,
	"./DEADSHOT.webp": 9647,
	"./DeerSimulatorChristmas.webp": 2011,
	"./DoodleArena.webp": 443,
	"./Drop & Merge-the-Numbers.jpg": 3221,
	"./Drop & Merge-the-Numbers.webp": 1171,
	"./ESPN-Arcade-Baseball.jpg": 7511,
	"./ESPN-Arcade-Baseball.webp": 6629,
	"./Eliza-Mall-Mania.jpg": 5012,
	"./Eliza-Mall-Mania.webp": 5516,
	"./Emoji-Ball-Blast.jpg": 3386,
	"./Emoji-Ball-Blast.webp": 6358,
	"./FighterLegendsDuo.webp": 1364,
	"./Fish-Eat-Getting-Big.jpg": 5210,
	"./Fish-Eat-Getting-Big.webp": 2718,
	"./Flames & Fortune.jpg": 3270,
	"./Flames & Fortune.webp": 9274,
	"./Foono-Online-Multiplayer.jpg": 8091,
	"./Foono-Online-Multiplayer.webp": 9277,
	"./Forward-Assault-Remix.jpg": 2510,
	"./Forward-Assault-Remix.webp": 3804,
	"./FractalCombatX.webp": 8038,
	"./FruitMassacre.webp": 1744,
	"./Funny-HairCut.jpg": 5684,
	"./Funny-HairCut.webp": 9750,
	"./FunnyBattleWarSimulator.webp": 4549,
	"./GasMonsters.webp": 305,
	"./GolfOrbit.webp": 9563,
	"./HazmobFPSOnlineShooter.webp": 2810,
	"./Hexa-Blast.jpg": 2286,
	"./Hexa-Blast.webp": 5946,
	"./Hextris.webp": 3120,
	"./IdleAirportTycoon.webp": 6382,
	"./LudoOnline.webp": 7256,
	"./MX-Offroad-Master.jpg": 2755,
	"./MX-Offroad-Master.webp": 2259,
	"./MegaRampCarGame.webp": 9453,
	"./Merge-Restaurant.jpg": 6023,
	"./Merge-Restaurant.webp": 4081,
	"./Mini-Golf-Club.jpg": 4128,
	"./Mini-Golf-Club.webp": 9128,
	"./Miniblox.jpg": 2273,
	"./Miniblox.webp": 3803,
	"./MonsterTruck.webp": 8436,
	"./Move-the-Rubber-Bands.jpg": 816,
	"./Move-the-Rubber-Bands.webp": 3750,
	"./NightCityRacing.webp": 5044,
	"./Nuts-Puzzle-Sort-By-Color.jpg": 3577,
	"./Nuts-Puzzle-Sort-By-Color.webp": 5845,
	"./Nuts-and-Bolts-Brainteasers.jpg": 7456,
	"./Nuts-and-Bolts-Brainteasers.webp": 946,
	"./OffroadLife3D.webp": 6462,
	"./OnlyUPGOParkour.webp": 4850,
	"./Pacman-Canvas.jpg": 5810,
	"./Pacman-Canvas.webp": 5780,
	"./ParkingLine.webp": 3545,
	"./ParkingPanic.webp": 4001,
	"./PianoTiles.webp": 6747,
	"./Punchers.jpg": 4071,
	"./Punchers.webp": 9821,
	"./Racing-Limits.jpg": 5588,
	"./Racing-Limits.webp": 730,
	"./RacingHorizon.webp": 5498,
	"./Ragdoll Archers.webp": 9524,
	"./Railwaybridgewinte.webp": 4378,
	"./Rally-Racer-Dirt.jpg": 6957,
	"./Rally-Racer-Dirt.webp": 6567,
	"./Road-Race-2d.jpg": 9312,
	"./Road-Race-2d.webp": 288,
	"./SantaHaircut.webp": 4218,
	"./Scandinavian-Mahjong.jpg": 7629,
	"./Scandinavian-Mahjong.webp": 4127,
	"./Shadow-Ninja-Revenge.jpg": 8437,
	"./Shadow-Ninja-Revenge.webp": 2131,
	"./Skillfite.io.jpg": 4114,
	"./Skillfite.io.webp": 6894,
	"./SnakeMerge.webp": 2949,
	"./Snakeio.webp": 8355,
	"./SniperCityStrike.webp": 4347,
	"./SniperGuerrillaAmbush.webp": 2771,
	"./SniperStrike.webp": 4060,
	"./SnowPlowTruck.webp": 2028,
	"./Solitaire.jpg": 2503,
	"./Solitaire.webp": 6327,
	"./Splatmans.webp": 5174,
	"./SquadBlast.jpg": 3731,
	"./SquadBlast.webp": 6817,
	"./Stickman-Moto-Race-Extreme.jpg": 4844,
	"./Stickman-Moto-Race-Extreme.webp": 3384,
	"./Sunset-Bike-Racing.jpg": 444,
	"./Sunset-Bike-Racing.webp": 6160,
	"./Super-Star-Car.jpg": 3140,
	"./Super-Star-Car.webp": 4848,
	"./SuperBikeTheChampion.webp": 4855,
	"./TableTennisWorldTour.webp": 6210,
	"./Tap-Tap-Shots.jpg": 8252,
	"./Tap-Tap-Shots.webp": 294,
	"./Tic-Tac-Toe-Soccer.jpg": 5627,
	"./Tic-Tac-Toe-Soccer.webp": 513,
	"./TicTacToe.webp": 5583,
	"./TrafficTour.webp": 8632,
	"./Tropical-Merge.jpg": 9848,
	"./Tropical-Merge.webp": 6648,
	"./Truck-Driving-Simulator-Game.jpg": 6070,
	"./Truck-Driving-Simulator-Game.webp": 9338,
	"./Wood-Block-Journey.jpg": 2787,
	"./Wood-Block-Journey.webp": 9037,
	"./Xtreme-DRIFT-Racing.jpg": 737,
	"./Xtreme-DRIFT-Racing.webp": 4085,
	"./XtremeMotoMayhem.webp": 5754,
	"./XtremedriftRacing.webp": 8615,
	"./YahooTennis.webp": 5900,
	"./ZE (1).png": 4658,
	"./backgroud.jpg": 2121,
	"./common_game_bg.jpeg": 5238,
	"./fav.ico": 6647,
	"./fav.png": 5404,
	"./grid_Frame.svg": 5629,
	"./hyper-jump-3d.jpg": 5986,
	"./hyper-jump-3d.webp": 9011,
	"./logo.png": 2806,
	"./logo192.png": 3864,
	"./logo512.png": 9292,
	"./zuppe-logo.png": 5823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;